




























import { useRoute, defineComponent, computed, ref, provide, onMounted } from '@nuxtjs/composition-api';
import Logo from 'components/theme/Header/Logo.vue';
import LazyHydrate from 'vue-lazy-hydration';
import { useUiState } from '@wemade-vsf/composables';
import AppHeader from 'components/theme/Alternate/AppHeader.vue';
import LoadWhenVisible from 'components/theme/utils/LoadWhenVisible.vue';

export default defineComponent({
  name: 'CheckoutLayout',
  components: {
    Logo,
    LazyHydrate,
    AppHeader,
    LoadWhenVisible,
    CartSidebar: () => import(/* webpackPrefetch: true */ 'components/checkout/CartSidebar.vue'),
    AppFooter: () => import(/* webpackPrefetch: true */ 'components/theme/AppFooter.vue'),
    Notification: () => import(/* webpackPrefetch: true */ 'components/theme/Notification.vue'),
  },
  setup() {
    const route = useRoute();
    const isThankYou = computed(() => route.value.name.startsWith('checkout-thank-you'));
    const isSveaCheckoutConfirmation = computed(() => route.value.path === '/sveacheckout/confirmation');

    const {
      isCartSidebarOpen
    } = useUiState();
    
    const taxOff = ref(true);
    provide("taxOff", taxOff);

    onMounted(() => {
      const savedPreference = localStorage.getItem("taxOff");
      if (savedPreference !== null) {
        taxOff.value = JSON.parse(savedPreference);
      }
    });


    return {
      route,
      isThankYou,
      isCartSidebarOpen,
      isSveaCheckoutConfirmation,
      taxOff,
    };
  },
});
